import Session from "../auth/Session";

const CompanyAssetFunctions = {
    getCompanyAssetsAsync: async function () {
        const token = Session.getToken();
        const response = await fetch(`api/CompanyAsset/GetCompanyAssets`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });

        return response;
    },
    postSaveCompanyAssetAsync: async function (formData) {
        const token = Session.getToken();
        const response = await fetch(`api/CompanyAsset/SaveCompanyAsset`, {
            method: "POST",
            body: JSON.stringify(formData),
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        
        return response;
    },
    postCertificateUploadAsync: async function (fileData) {
        const token = Session.getToken();
        const response = await fetch(`api/CompanyAsset/UploadCertificateFile`, {
            method: "POST",
            body: fileData,
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        return data;
    },
    getCertificateFileAsync: async function (assetCertId) {
        const token = Session.getToken();
        const response = await fetch('api/CompanyAsset/GetAssetCertificateFileAsync?assetCertificateId=' + assetCertId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
        });
        const data = response;
        return data;
    },
}

export default CompanyAssetFunctions;